// extracted by mini-css-extract-plugin
export default {"logo":"Brand_logo__WRf4s","title":"Brand_title__aazuQ"};